import { EN, PERSON_TYPE } from "shared/constants";
import { getPropsForSlug, getStaticPathsForType } from "shared/staticHelpers";
import { LoadingPage } from "containers/LoadingPage";
import { PersonDetailPage } from "containers/PersonDetailPage";
import { useRouter } from "next/router";

export async function getStaticProps({ locale, params: { slug } }) {
  return await getPropsForSlug({ locale, type: PERSON_TYPE, slug });
}

export async function getStaticPaths() {
  return await getStaticPathsForType({ locale: EN, type: PERSON_TYPE });
}

const PageToExport = (props) => {
  const { isFallback } = useRouter();

  if (isFallback) {
    return <LoadingPage />;
  }

  return <PersonDetailPage {...props} />;
};

export default PageToExport;
